import React, { useEffect, useState, useMemo } from 'react'
import DashboardTodaysDeviceStatus from './DashboardTodaysDeviceStatus';
import { DASHBOARD_INTERVAL_TIMER } from '../../config';
import { Box, CardContent, Icon } from '@mui/material';
import DashboardTodaysDeviceDetails from './DashboardTodaysDeviceDetails';

const DashboardTodaysSeverityDetails = ({
  SiteName,
  handleModalShow,
  siteId,
  getcsvFileName,
  widget,
  deviceStatus,
  alertsData
}) => {
  // Flatten alertsData if it's an object with keys (as in your API response)
  const flatAlertsData = useMemo(() => (
    Array.isArray(alertsData)
      ? alertsData
      : alertsData && typeof alertsData === 'object'
        ? Object.values(alertsData).flat()
        : []
  ), [alertsData]);

  // Default severities
  const defaultSeverities = [
    { SeverityTitle: "Extreme", OpenCount: 0, CloseCount: 0, AckCount: 0 },
    { SeverityTitle: "High", OpenCount: 0, CloseCount: 0, AckCount: 0 },
    { SeverityTitle: "Moderate", OpenCount: 0, CloseCount: 0, AckCount: 0 },
    { SeverityTitle: "Low", OpenCount: 0, CloseCount: 0, AckCount: 0 },
  ];

  const [severityData, setSeverityData] = useState(defaultSeverities);

  // Parse alertsData for WidgetID 15
  useEffect(() => {
    const widget15 = flatAlertsData.find(w => w.WidgetID === 15 && w.WidgetData);
    if (!widget15 || !widget15.WidgetData) {
      setSeverityData(defaultSeverities);
      return;
    }
    const data = widget15.WidgetData;
    const severities = defaultSeverities.map(sev => {
      const sevData = data[sev.SeverityTitle] || {};
      return {
        SeverityTitle: sev.SeverityTitle,
        OpenCount: sevData.Open || 0,
        CloseCount: sevData.Closed || 0,
        AckCount: sevData.Acknowledged || 0,
      };
    });
    setSeverityData(severities);
  }, [flatAlertsData]);

  const severityClasses = {
    Extreme: "extreme",
    High: "high",
    Moderate: "moderate",
    Low: "low",
  };

  const severityColors = {
  Extreme: "#dd2121",
  High: "#d06841",  
  Moderate: "#daa926", 
  Low: "#83ba2b",  
};

  return (
    <div className='m-2'>
      <div>
        <h6 className='AlertsHeaderText'>Today's Alerts</h6>
          <>
            <div className="Alertcontainer">
              {severityData.map((alert, index) => (
                <div className='systemHealth m-0 WidgetPadding p-0' key={index}>
                  <Box sx={{ height: 8, backgroundColor: severityColors[alert.SeverityTitle] , borderTopLeftRadius: 8, borderTopRightRadius: 8 }} />
                  <CardContent className="CardContentSeverity">
                    <Box display="flex" alignItems="center" mb={2}>
                      <h5 className='singleKpiText'>{alert.SeverityTitle}</h5>
                    </Box>
                    <hr></hr>
                    <div className="content ContentBackground">
                      <div>
                        <span>Open</span>
                        <h3 className='singleKpiText' style={{ cursor: handleModalShow ? 'pointer' : 'default' }}
                          onClick={() => handleModalShow({ AlertStatus: "Open", Severity: alert.SeverityTitle }, "Alert", 1, { SiteID: [siteId] }, getcsvFileName('Alert', 'Open'), alert.SeverityTitle)}>{alert.OpenCount}</h3>
                      </div>
                      <div>
                        <span>Close</span>
                        <h3 className='singleKpiText' style={{ cursor: handleModalShow ? 'pointer' : 'default' }}
                          onClick={() => handleModalShow({ AlertStatus: "Closed", Severity: alert.SeverityTitle }, "Alert", 1, { SiteID: [siteId] }, getcsvFileName('Alert', 'Closed'), alert.SeverityTitle)}>{alert.CloseCount}</h3>
                      </div>
                      <div>
                        <span>Ack</span>
                        <h3 className='singleKpiText' style={{ cursor: handleModalShow ? 'pointer' : 'default' }}
                          onClick={() => handleModalShow({ AlertStatus: "Acknowledged", Severity: alert.SeverityTitle }, "Alert", 1, { SiteID: [siteId] }, getcsvFileName('Alert', 'Acknowledged'), alert.SeverityTitle)}>{alert.AckCount}</h3>
                      </div>
                    </div>
                  </CardContent>
                </div>
              ))}
             </div>
          </>
      </div>

      <div className='mt-3'>
        <h6 className='AlertsHeaderText'>Today's Device Status</h6>
        <DashboardTodaysDeviceDetails SiteName={SiteName} handleModalShow={handleModalShow} getcsvFileName={getcsvFileName} siteId={siteId} deviceStatus={deviceStatus} />
      </div>
    </div>
  )
}

export default DashboardTodaysSeverityDetails